/**
 * Controller: InventoryCreateModal
 */
angular.module('acme.view.application.coupons.categories.create.removeCouponModal.controllers', [])
.controller('RemoveCouponModalController', [ '$scope', '$uibModalInstance', 'couponName', function ($scope, $uibModalInstance, couponName) {

    $scope.errors = [];

    $scope.model = {
      name: couponName
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

}]);